import { createIcon } from './createIcon'

export const MilestoneLocationPinIcon = createIcon({
  displayName: 'MilestoneLocationPinIcon',
  viewBox: '0 0 12 13',
  path: [
    <path
      id="Icon"
      fill="none"
      d="M6 11.5C7 11.5 10 7.70914 10 5.5C10 3.29086 8.20914 1.5 6 1.5C3.79086 1.5 2 3.29086 2 5.5C2 7.70914 5 11.5 6 11.5Z"
      stroke="currentColor"
      strokeLinecap="round"
    />,
    <circle id="Ellipse 166" cx="6" cy="6" r="1" fill="currentColor" />,
  ],
})
